import { useTranslation } from 'react-i18next';

import minivan from '@/assets/images/about-us/about-us-minivan.webp';
import minivanMobile from '@/assets/images/about-us/about-us-minivan-360.webp';

import { useScreenType } from '@/hooks/useScreenType';

import { Container } from '@/components/Container';
import { Title } from '@/components/Title';
import { Cloud } from '@/components/Cloud';

import styles from './AboutUs.module.scss';

export function AboutUs() {
  const { t } = useTranslation('aboutUs');
  const { screenType } = useScreenType();

  const paragraphs = t('paragraphs', { returnObjects: true }) as string[];

  return (
    <section className={styles.aboutUs} id="about-us">
      <Cloud className={styles.aboutUs__cloud1} />
      <Cloud className={styles.aboutUs__cloud2} />
      <Container className={styles.aboutUs__container}>
        <div className={styles.aboutUs__image}>
          <img
            src={screenType === 'mobile' ? minivanMobile : minivan}
            alt="Minivan"
            loading="lazy"
          />
        </div>
        <div className={styles.aboutUs__content}>
          <Title className={styles.aboutUs__title}>{t('title')}</Title>
          {paragraphs.map((paragraph, index) => (
            <p key={index} className={styles.aboutUs__paragraph}>
              {paragraph}
            </p>
          ))}
          <div className={styles.quote}>
            <p className={styles.quote__text}>{t('quote.text')}</p>
            <p className={styles.quote__author}>{t('quote.author')}</p>
          </div>
        </div>
      </Container>
    </section>
  );
}
